import React, { FC, useContext } from 'react';
import classes from './LicenseHasExpiredModal.module.scss';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { LicenseKeySection } from './LicenseKeySection';
import { LicenseWarningIcon, MailIcon, PhoneIcon } from '../../../assets/icons';
import { LicenseContext } from '../../../context/LisenceContext/LicenseContext';
import Typography, { TypographyVariant } from '../../Typography/Typography';
import modalBase from '../../ModalBase/ModalBase.module.scss';

export const LicenseHasExpiredModal: FC = () => {
  const { isLicenseExpired, currentLicenseKey } = useContext(LicenseContext);

  return (
    <>
      {isLicenseExpired &&
        createPortal(
          <div className={classNames(modalBase.modal, modalBase.active, classes.licenseHasExpiredModalWrapper)}>
            <div className={classNames(modalBase.container, classes.contentContainer)}>
              <LicenseWarningIcon className={classes.warningIcon} />

              {currentLicenseKey ? (
                <>
                  <Typography
                    variant={
                      TypographyVariant.h2_semibold
                    }>{`Срок действия лицензиии\n${currentLicenseKey} истек`}</Typography>
                  <Typography variant={TypographyVariant.text_secondary_regular}>
                    За продлением лицензии обратитесь в ООО Техно-Скай
                  </Typography>
                </>
              ) : (
                <Typography variant={TypographyVariant.h2_semibold}>
                  {
                    'Для входа в административную панель введите ключ действующей лицензии или обратитесь в ООО "Техно-Скай"'
                  }
                </Typography>
              )}

              <LicenseKeySection />

              <div className={classes.contactsContainer}>
                <div className={classes.contact}>
                  <PhoneIcon className={classes.phoneIcon} />
                  <Typography variant={TypographyVariant.h4_regular}>+375(29) 198 00 04</Typography>
                </div>

                <div className={classes.contact}>
                  <MailIcon className={classes.mailIcon} />
                  <Typography variant={TypographyVariant.h4_regular}>info@high-tech.by</Typography>
                </div>
              </div>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};
